import React from 'react';
import styled from 'styled-components';
import BlueRewardsLogo from './BlueRewardsLogo';
import { trackAnalyticsNew, attachLocale } from '../../../../lib/utils';
import { DATA_TRACK_TYPE_INTERNAL } from '../../../../lib/constants';

const LogoContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`;

const ShopsLink = styled.a`
  display: inline-flex;
  text-decoration: none;
`;

const ShopsLogoContainer = (props) => {
  const {
    shopsLogoNavSlot = {},
    location = 'page',
    size,
    locale,
  } = props;

  const localizedUrl = attachLocale(shopsLogoNavSlot.url, locale);
  const trackShops = trackAnalyticsNew({
    url: localizedUrl,
    location,
    name: 'blue-rewards-logo',
  });

  return (
    <LogoContainer>
      {shopsLogoNavSlot.url ? (
        <ShopsLink
          id={trackShops.dataTrackingId}
          data-track-id={trackShops.dataTrackingId}
          data-track-click={trackShops.dataTrack}
          data-track-type={DATA_TRACK_TYPE_INTERNAL}
          href={trackShops.url}
        >
          <BlueRewardsLogo text={shopsLogoNavSlot.text} size={size} locale={locale} />
        </ShopsLink>
      ) : (
        <BlueRewardsLogo text={shopsLogoNavSlot.text} size={size} locale={locale} />
      )}
    </LogoContainer>
  );
};

export default ShopsLogoContainer;
